import { render, staticRenderFns } from "./ManagersView.vue?vue&type=template&id=87dad170&scoped=true&"
import script from "./ManagersView.vue?vue&type=script&lang=js&"
export * from "./ManagersView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87dad170",
  null
  
)

export default component.exports